<template>
  <div class="owc-wb-accordion-item">
    <SlotContainer
      refName="slot-accordion-content"
      wrapperClass="owc-wb-accordion-content"
      :slot-component-data="JSON.stringify({ isPartOfAccordion: true })"
    >
      <slot></slot>
    </SlotContainer>
  </div>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { WbAccordionItemComponent } from './WbAccordion';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
export default (ComponentInitializeDispatcher as WbAccordionItemComponent).extend({
  name: 'owc-wb-accordion-item',
  components: {
    SlotContainer,
  },
  computed: {
    isDarkMode: function() {
      return Boolean(this.componentData?.darkMode);
    },
  },
});
</script>
